module.exports = __webpack_public_path__ + "static/media/crown.995be102.svg";